module.exports = __webpack_public_path__ + "static/timeline1993-2-9fcb42f74211eafd2fbb7b0b8c478d42.jpeg";